// src/components/common/ScrollToTop.js
import { useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
    const { pathname } = useLocation();

    // Use useLayoutEffect for synchronous scroll before paint
    useLayoutEffect(() => {
        // Scroll to top immediately on route change
        window.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
    }, [pathname]);

    return null;
};

export default ScrollToTop;